import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";
import AxiosInterceptor from "../../Services/axiosIntercepter";

const loginDetails = async (payload) => {
  const { url, body } = payload;
  const result = await AxiosInterceptor.post(url, body);
  return result;
};

export function* LOGINSAGA() {
  yield takeEvery(actions.LOGIN_REQUEST, function* ({ payload }) {
    try {
      const res = yield call(loginDetails, payload);
      if (res.data.status_code === 1) {
        localStorage.setItem("loginType", res?.data?.login_type);
        yield put({
          type: actions.LOGIN_SUCCESS,
          loginType: res?.data?.login_type,
          message: res?.data?.message,
          status_code: res?.data?.status_code,
        });
      } else {
        yield put({
          type: actions.LOGIN_ERROR,
          loginType: "",
          message: res?.data?.message,
          error: "Failed to login. Please try again.",
        });
      }
    } catch (error) {
      yield put({
        type: actions.LOGIN_ERROR,
        loginType: "",
        error: error?.response?.data?.message,
      });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(LOGINSAGA)]);
}
